<template>
  <el-dialog
    ref="dialog"
    :visible.sync="visible"
    :before-close="handleClose"
    append-to-body
    :show-close="false"
    custom-class="url-dialog"
  >
    <div class="content">
      <img src="@/assets/images/leave-text.png" alt="" class="leave-img" />
      <img src="@/assets/images/role-img.png" alt="" class="role-img" />
      <div class="leave-text">即将离开GAMEKEE.COM</div>
      <div class="content-box">
        <div class="leave-url">{{ message }}</div>
        <div class="btn">
          <div class="continue" @click="handleConfirm">继续访问</div>
          <div class="cancel" @click="handleCancel">取消</div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      visible: true
    };
  },
  methods: {
    handleClose(done) {
      // 无论用户点击“×”还是“取消”，都执行关闭逻辑
      this.handleCancel();
      done(); // 必须调用 done() 才能真正关闭弹窗
    },
    handleConfirm() {
      this.$emit("confirm");
      this.$refs.dialog.close(); // 关闭弹窗
    },
    handleCancel() {
      this.$emit("cancel");
      this.$refs.dialog.close(); // 关闭弹窗
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .url-dialog {
  width: max-content;
  margin-top: 20vh !important;
  background: transparent;
  box-shadow: none;

  .el-dialog__header {
    display: none !important;
  }

  .el-dialog__body {
    padding: 0 !important;
    z-index: 100;
    width: 335px !important;
    height: 192px !important;
    margin: 0 auto !important;
    background: transparent !important;

    .content {
      position: relative;
      z-index: 100;
      width: 335px !important;
      height: 192px !important;
      background: url("~@/assets/images/confirm-bg.png") no-repeat;
      background-size: 100% 100%;
      margin: 0 auto;

      .role-img {
        width: 129px;
        height: 126px;
        position: absolute;
        right: 0;
        top: -93px;
        z-index: 50;
      }

      .leave-img {
        position: absolute;
        width: 127px;
        height: 45px;
        right: 110px;
        top: -70px;
      }

      .leave-text {
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: 800;
        font-size: 15px;
        color: #ffffff;
        height: 45px;
        width: 100%;
        padding: 0 11px;
        display: flex;
        align-items: center;
      }

      .content-box {
        width: calc(100% - 22px);
        margin: 0 auto;
        height: 136px;
        background: #ffffff;
        border-radius: 13px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        row-gap: 20px;

        .leave-url {
          width: calc(100% - 24px);
          margin: 0 auto;
          font-weight: 400;
          font-size: 13px;
          color: #333333;
          background: #ebebeb;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          padding: 11px 13px;
        }

        .btn {
          width: 100%;
          padding: 0 11px;
          height: 36px;
          display: flex;
          justify-content: space-between;

          .continue {
            width: 132px;
            height: 36px;
            background: #3caafc;
            border-radius: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 800;
            font-size: 14px;
            color: #ffffff;
            cursor: pointer;
          }

          .cancel {
            width: 132px;
            height: 36px;
            border-radius: 20px;
            border: 1px solid #3caafc;
            font-weight: 800;
            font-size: 14px;
            color: #3caafc;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>
